import React, { useContext } from 'react'
import { Icon, Menu } from 'semantic-ui-react'

import { RutubeIcon } from '@niimko/drupal_menu'

import { RutubeIconWrapper, Icons, Circle } from './style'

import ThemeContext from '@/theme/context'

export const Contacts = ({ color, currentAct = undefined }: { color: string, currentAct: string|undefined}) => {
    const { primaryColor } = useContext(ThemeContext);
    const isOlymps = currentAct === 'olymp' || currentAct === 'olymp_en'
    const vkHref = (currentAct === 'fieb' || currentAct === 'tfieb') ? '//vk.com/fieb_for_you' : isOlymps ? '//vk.com/iolymps_club' : '//vk.com/niimko'

    return (
        <Icons $color={color} $hoverColor={primaryColor} $mobileColor={currentAct === 'default' ? color : primaryColor} $isOlymps={isOlymps}>
            <Menu.Item href={vkHref} target="_blank">
                <Circle>
                    <Icon name='vk'/>
                </Circle>
            </Menu.Item>
            <Menu.Item href="//t.me/i_exam" target="_blank">
                <Circle>
                    <Icon name='telegram plane'/>
                </Circle>
            </Menu.Item>
            <Menu.Item href="https://rutube.ru/channel/28032892/" target="_blank">
                <Circle>
                    <RutubeIconWrapper>
                        <RutubeIcon />
                    </RutubeIconWrapper>
                </Circle>
            </Menu.Item>
        </Icons>
    )
}